/* tslint:disable */

/**
 */
export class UpdateStdEqpLayoutParams {
    orientation?: number;
    lengthInterval?: number;
    widthInterval?: number;
    toc?: number;
    crate?: number;
    nbShelves?: number;
    studyClean?: boolean;
    shelvesWidth?: number;
    shelvesLength?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/update-std-eqp-layout-params.ts